module.exports = __webpack_public_path__ + "static/img/irole.577487c.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/jw/irole.png
// module id = XfKh
// module chunks = 7